import ApplicationController from "application_controller.js";

//* Opens, closes and toggles a Bootstrap modal by id, and closes it when a .close-modal link inside it is clicked.
//* Takes the Modal class of the bundle, because a bundle must not mix the full "bootstrap" with "bootstrap/js/dist/*".
//* Import index.js in bundles with the full "bootstrap" and dist.js in bundles that import plugins one by one.
//*   <button data-controller="modal--bootstrap" data-modal--bootstrap-id-value="myModal" data-action="modal--bootstrap#show">Open</button>
export default (Modal) => class extends ApplicationController  {
  debug = false;
  static values = {
    id: String,
  };

  connect() {
    this.log_function("connect");

    this.modalElement = document.getElementById(this.idValue);
    this.modalInstance = Modal.getOrCreateInstance(this.modalElement);
    this.boundCloseOnLinkClick = this.closeOnLinkClick.bind(this);
    this.modalElement.addEventListener("click", this.boundCloseOnLinkClick);
  }

  closeOnLinkClick(event) {
    if (event.target.closest(".close-modal")) {
      this.hide();
    }
  }

  show(){
    this.log_function("show");

    this.modalInstance.show();
  }

  hide(){
    this.log_function("hide");

    this.modalInstance.hide();
  }

  toggle(){
    this.log_function("toggle");

    this.modalInstance.hide();
  }

  update() {
    this.log_function("update");

    this.modalInstance.handleUpdate();
  }

  dispose() {
    this.log_function("dispose");

    this.modalInstance.handleUpdate();
  }

  disconnect(){
    this.log_function("disconnect");

    if (this.modalElement && this.boundCloseOnLinkClick) {
      this.modalElement.removeEventListener("click", this.boundCloseOnLinkClick);
    }

    this.dispose();
  }
};
